import React from 'react';
import { DevicePhoneMobileIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';
import { APK_FILENAME, APK_SIZE_LABEL, APK_URL, isIOS } from '../config/download';

/**
 * Bouton de téléchargement de l'application Android.
 *
 * Le lien pointe directement sur l'APK : pas de gestionnaire de clic, pas de
 * redirection, le navigateur s'en charge et la barre de progression reste
 * visible. L'attribut `download` impose le nom du fichier enregistré.
 *
 * Sur iOS l'APK ne sert à rien : on le dit plutôt que de laisser l'utilisateur
 * télécharger 75 Mo pour rien.
 *
 * Deux présentations :
 *   - `compact` (défaut) : une ligne, pour la barre de navigation
 *   - `card`             : le format des anciens boutons Google Play / App Store
 */

/** Robot Android, pour le format carte. */
const AndroidIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="#3DDC84" aria-hidden="true">
    <path d="M17.6 9.48l1.84-3.18a.38.38 0 0 0-.14-.52.38.38 0 0 0-.52.14l-1.86 3.22a11.4 11.4 0 0 0-9.84 0L5.22 5.92a.38.38 0 0 0-.52-.14.38.38 0 0 0-.14.52L6.4 9.48A10.8 10.8 0 0 0 1 18h22a10.8 10.8 0 0 0-5.4-8.52M7 15.25a1.25 1.25 0 1 1 1.25-1.25A1.25 1.25 0 0 1 7 15.25m10 0A1.25 1.25 0 1 1 18.25 14 1.25 1.25 0 0 1 17 15.25" />
  </svg>
);

const DownloadAppButton = ({
  className = '',
  variant = 'compact',
  showSize = true,
  label = "Télécharger l'app",
  onDone,
}) => {
  const onIos = isIOS();

  const handleIosClick = (event) => {
    event.preventDefault();
    toast('L\'application iOS arrive bientôt. Ce fichier est réservé à Android.', { icon: '🍏' });
    if (onDone) onDone();
  };

  const commonProps = {
    href: APK_URL,
    download: APK_FILENAME,
    onClick: onIos ? handleIosClick : onDone,
    className,
    // L'APK n'est pas une page : on évite que le navigateur tente de le rendre
    type: 'application/vnd.android.package-archive',
  };

  if (variant === 'card') {
    return (
      <a {...commonProps}>
        <AndroidIcon className="w-8 h-8 shrink-0" />
        <div className="text-left">
          <span className="text-[10px] text-gray-400 block uppercase tracking-wide">
            Téléchargement direct
          </span>
          <span className="text-white font-semibold text-lg block leading-tight">
            {onIos ? 'Bientôt sur iOS' : 'Application Android'}
          </span>
          {showSize && !onIos && (
            <span className="text-[11px] text-gray-400 block">APK · {APK_SIZE_LABEL}</span>
          )}
        </div>
      </a>
    );
  }

  return (
    <a {...commonProps}>
      <DevicePhoneMobileIcon className="h-4 w-4" />
      <span>
        {label}
        {showSize && !onIos && (
          <span className="opacity-60"> · Android {APK_SIZE_LABEL}</span>
        )}
      </span>
    </a>
  );
};

export default DownloadAppButton;
